import React from 'react';
import { getCustomOptionPriceModifier } from './customOptionUtils';

const PriceDisplayWithCustomOption = ({ product, currency, customOption = null, selectedSet = null, accessoriesModifier = 0, className = "" }) => {
  // Set price overrides everything
  if (selectedSet && selectedSet.price && selectedSet.price[currency] !== undefined) {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <span className="text-lg font-semibold text-brownSkin">
          {(parseFloat(selectedSet.price[currency]) + accessoriesModifier).toFixed(2)} {currency}
        </span>
      </div>
    );
  }

  const isOnSale = product.is_on_sale && product.sale_discount_percentage > 0;
  const originalPrice = product[currency];
  const discountedPrice = product[`discounted_${currency}`] || originalPrice;

  const getPriceWithCustomOption = (basePrice) => {
    const modifier = getCustomOptionPriceModifier(product.custom_options, customOption, currency);
    return parseFloat((parseFloat(basePrice) + modifier + accessoriesModifier).toFixed(2));
  };

  const finalPrice = getPriceWithCustomOption(discountedPrice);
  const originalPriceWithCustomOption = getPriceWithCustomOption(originalPrice);

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {isOnSale ? (
        <>
          <span className="text-lg font-semibold text-red-600">
            {finalPrice} {currency}
          </span>
          <span className="text-sm text-gray-500 line-through">
            {originalPriceWithCustomOption} {currency}
          </span>
          <span className="text-xs bg-red-100 text-red-600 px-2 py-1 rounded-full font-medium">
            -{product.sale_discount_percentage}%
          </span>
        </>
      ) : (
        <span className="text-lg font-semibold text-brownSkin">
          {finalPrice} {currency}
        </span>
      )}
    </div>
  );
};

export default PriceDisplayWithCustomOption;
